export default __webpack_public_path__ + "953f7588224233d0e546bb54528870be.json";